import sensors from '../../../../utils/sensors'
import { store } from '../../../../app/store'
import { PAYMENT_CONFIG, getVipLevelForTracking } from './paymentConfig'
import { GoodsItem } from '../types'

/**
 * AI照片王语境下的字段覆盖(2026-06-11 spec rid=1124)。
 * 照片王打开弹窗时 customContent.variant='aiPhotoPaywall'(aiPhotoPaywallCustomContent):
 *  - requirement_id: 覆盖成 1124, 让 rid=1124 的平台验收能过滤到这些事件;
 *    非照片王业务 variant 不匹配 → 返回空对象, 维持原 requirement_id 不受影响
 *  - string2: customContent.data.trackSource(我的积分弹窗 等三个来源), 未携带不上报
 */
const aiPhotoOverrides = (): { string2?: string; requirement_id?: number } => {
  try {
    const state = store.getState() as any
    const variant = state?.main?.paymentStatus?.customContent?.variant
    if (variant !== 'aiPhotoPaywall') return {}
    const trackSource =
      state?.main?.paymentStatus?.customContent?.data?.trackSource
    return {
      requirement_id: 1124,
      ...(trackSource ? { string2: trackSource } : {})
    }
  } catch {
    return {}
  }
}

/**
 * 商品点击埋点
 */
export const trackGoodsClick = (
  clickItem: string,
  goods: GoodsItem | null,
  groupID: string,
  sourceDetail: string,
  isFromToView: boolean,
  paramas?: object
) => {
  if (!goods) return
  paramas = paramas || {}

  sensors.track('web_click_page_workgroup_open_vip', {
    clickItem,
    groupID,
    vipType: goods?.content?.vipKind,
    productID: goods?.id,
    vipLevel: getVipLevelForTracking(goods?.content?.vipKind),
    bool1: isFromToView,
    pageType: PAYMENT_CONFIG.SENSOR_TRACKING.PAGE_TYPE,
    source_detail: sourceDetail,
    track_sign: PAYMENT_CONFIG.SENSOR_TRACKING.TRACK_SIGN,
    requirement_id: PAYMENT_CONFIG.SENSOR_TRACKING.REQUIREMENT_ID,
    ...aiPhotoOverrides(),
    ...paramas
  })
}

/**
 * 商品类型选择埋点
 */
export const trackGoodsTypeSelection = (
  goods: GoodsItem,
  groupID: string,
  sourceDetail: string,
  isFromToView: boolean,
  params: object
) => {
  trackGoodsClick('vipType', goods, groupID, sourceDetail, isFromToView, params)
}

/**
 * 支付成功埋点
 */
export const trackPaymentSuccess = (groupID: string) => {
  sensors.track('web_get_purchase_vip_result', {
    result: 'suc',
    groupID
  })
}

/**
 * 支付失败埋点
 */
export const trackPaymentFailure = (groupID: string) => {
  sensors.track('web_get_purchase_vip_result', {
    result: 'fail',
    groupID
  })
}

/**
 * SVIP限制弹窗埋点
 */
export const trackSvipRestrictionShow = (sourceDetail: string) => {
  sensors.track('web_get_action_workgroup_vip_need_svip', {
    actionType: 'showPop',
    source_detail: sourceDetail
  })
}

/**
 * 客服点击埋点
 */
export const trackConsultClick = (sourceDetail: string) => {
  sensors.track('web_click_page_workgroup_open_vip', {
    clickItem: 'contactUs',
    source_detail: sourceDetail,
    pageType: PAYMENT_CONFIG.SENSOR_TRACKING.PAGE_TYPE,
    track_sign: PAYMENT_CONFIG.SENSOR_TRACKING.TRACK_SIGN,
    requirement_id: PAYMENT_CONFIG.SENSOR_TRACKING.REQUIREMENT_ID,
    ...aiPhotoOverrides()
  })
}

/**
 * 关闭弹窗埋点
 */
export const trackModalClose = (sourceDetail: string) => {
  sensors.track('web_click_page_workgroup_open_vip', {
    clickItem: 'close',
    pageType: PAYMENT_CONFIG.SENSOR_TRACKING.PAGE_TYPE,
    source_detail: sourceDetail,
    track_sign: PAYMENT_CONFIG.SENSOR_TRACKING.TRACK_SIGN,
    requirement_id: PAYMENT_CONFIG.SENSOR_TRACKING.REQUIREMENT_ID,
    ...aiPhotoOverrides()
  })
}

/**
 * 弹窗打开埋点
 */
export const trackModalShow = (sourceDetail: string) => {
  sensors.track('web_click_page_workgroup_open_vip', {
    clickItem: 'show',
    source_detail: sourceDetail,
    pageType: PAYMENT_CONFIG.SENSOR_TRACKING.PAGE_TYPE,
    track_sign: PAYMENT_CONFIG.SENSOR_TRACKING.TRACK_SIGN,
    requirement_id: PAYMENT_CONFIG.SENSOR_TRACKING.REQUIREMENT_ID,
    ...aiPhotoOverrides()
  })
}
